import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

class Page extends Component {
    render() {
        const {page} = this.props;

        let title = page.title.rendered;
        if (page.title.html !== '') {
            title = page.title.html;
        }

        return (
            <article className="page">
                <header>
                    <div className="row">
                        <div className="col col-9">
                            <h1>{ReactHtmlParser(title)}</h1>

                            {page.subtitle.rendered !== '' &&
                                <div className="description">{ReactHtmlParser(page.subtitle.rendered)}</div>
                            }
                        </div>
                    </div>
                </header>
                <div className="row row-content">
                    <div className="col col-12">
                        <div className="content-inner">
                            {ReactHtmlParser(page.content.rendered)}
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}

Page.propTypes = {
    page: PropTypes.object.isRequired
};

export default Page;


// WEBPACK FOOTER //
// ./src/features/Content/components/Page.js